<template>
<div class="chapter">
<div class="inner_page">
<p class="head">P<span class="small">REFACE</span></p>
<p class="noindent">Why would a pronounced historical purist write ghost tales? More than once I have faced that question. Basically, it is because of public demand. For several years, I have been pressured to write such a book. In my constant quest for historical information, I have heard hundreds of ghost tales. They seem to be a byproduct of historical research.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?62dc1e97